<template>
    <validate-form ref="form">
        <portal to="buttons">
            <b-button variant="outline-secondary" type="reset" @click="getItem" class="mx-5 my-5">
                Annuller
            </b-button>

            <b-button @click="saveItem" variant="primary" class="mx-5 my-5">
                {{ editing ? "Gem ændringer" : "Opret producent" }}
            </b-button>
        </portal>
        <b-form>
            <b-row>
                <b-col cols="12" md="5">
                    <b-card>
                        <FormGroup v-model="item.name" label="Navn" rules="required"></FormGroup>

                        <FormGroup v-model="item.url" label="URL" rules=""></FormGroup>

                        <FormGroup v-model="item.pageTitle" label="Sidetitel" rules="required"></FormGroup>

                        <FormGroup v-model="item.sort" label="Sortering" rules="" type="number"></FormGroup>

                        <FormGroup label="Begrænset til butikker" rules="">
                            <template #input="{state}">
                                <v-select v-model="item.stores" multiple :options="$store.state.stores" placeholder="Vælg butikker" :reduce="x => x.id">
                                    <template slot="option" slot-scope="option">
                                        {{ option.name }}
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.name }}
                                    </template>
                                </v-select>
                            </template>
                        </FormGroup>

                        <FormGroup label="Skjul i menu" rules="" no-label>
                            <template #input="{state}">
                                <b-form-checkbox v-model="item.hideInMenu" :state="state">
                                    Skjul i menu
                                </b-form-checkbox>
                            </template>
                        </FormGroup>

                        <FormGroup label="Skjul i menu" rules="" no-label>
                            <template #input="{state}">
                                <b-form-checkbox v-model="item.inactive" :state="state">
                                    Inaktiv
                                </b-form-checkbox>
                            </template>
                        </FormGroup>
                    </b-card>
                </b-col>
                <b-col cols="12" md="7">
                    <b-card>
                        <b-tabs>
                            <b-tab title="Beskrivelse 1">
                                <editor v-model="item.description1" :init="editorConfig" api-key="1omqmjmnhfis5mkj5e0mj2rjzh22wjqhi39nq3ala2vq3yvo"></editor>
                            </b-tab>
                            <b-tab title="Beskrivelse 2">
                                <editor v-model="item.description2" :init="editorConfig" api-key="1omqmjmnhfis5mkj5e0mj2rjzh22wjqhi39nq3ala2vq3yvo"></editor>
                            </b-tab>
                        </b-tabs>
                    </b-card>

                    <b-card>
                        <b-overlay :show="!editing" rounded="sm">
                            <Images v-model="item.images" :url="'/api/brands/upload-images/' + id" :delete-url="'/api/brands/delete-image/' + id" 
                                    @uploaded="getItem" @deleted="getItem"></Images>

                            <template #overlay>
                                <feather-icon icon="InfoIcon" size="18" class="mb-2" />
                                <span class="px-10">Opret producent for at uploade billeder</span>
                            </template>
                        </b-overlay>
                    </b-card>
                </b-col>
            </b-row>
        </b-form>

    </validate-form>

</template>

<script>
    import Toast from '@/components/_toast.vue'

    export default {
        components: {},
        data: () => ({
            item: {
                id: null
            },
            editorConfig: {
                height: 300,
                plugins: [
                    'lists link image paste code'
                ],
                toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code',
                menubar: ""
            }
        }),
        computed: {
            id() {
                return this.$route.params.id
            },
            editing() {
                return this.id != "create"
            }
        },
        created() {
            if (this.editing) {
                this.getItem()
            } else {
                this.$store.dispatch("app/UPDATE_PAGETITLE", "Opret producent")
            }
        },
        mounted() { },
        methods: {
            getItem() {
                if (this.editing) {
                    this.$http.get("/api/brands/" + this.id).then(x => {
                        this.item = x.data

                        this.$store.dispatch("app/UPDATE_PAGETITLE", x.data.name)
                    })
                } else {
                    this.$router.push("/brands")
                }
            },
            saveItem() {
                this.$refs.form.validate().then(success => {
                    if (success) {
                        this.$http.post("/api/brands/save", this.item).then(x => {

                            this.$toast({
                                component: Toast,
                                props: {
                                    title: x.data.result,
                                    icon: 'CheckCircleIcon',
                                    variant: 'success',
                                },
                            })

                            if (x.data.data) {
                                this.$router.replace({ name: "brand", params: { id: x.data.data } })
                            }

                            this.getItem()
                        })
                    }
                })
            }
        },
    }
</script>